import {
    AdditionalWidgetProperties,
    useRefinementList,
    UseRefinementListProps,
} from 'react-instantsearch';

const useOptimizedRefinementList = (
    props: UseRefinementListProps,
    additionalWidgetProperties?: AdditionalWidgetProperties,
) => {
    const {
        items: allItems,
        refine,
        ...rest
    } = useRefinementList(
        {
            escapeFacetValues: false,
            limit: 1000,
            ...props,
        },
        additionalWidgetProperties,
    );

    return {
        ...rest,
        allItems,
        refine,
    };
};
export default useOptimizedRefinementList;
